<template>
  <!-- exam dialog -->
  <v-row justify="center">
    <v-dialog
      v-model="isOpen"
      scrollable
      width="750px"
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-format-annotation-plus</v-icon
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.addEditExam'
              )
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon dark @click="checkToSave" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span class="subtitle-1">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.close'
              )
            }}</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pt-3">
          <v-tabs class v-model="main_tabs" grow>
            <v-tab class="subtitle-1 tab-exam uppercast-unset" href="#detail">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.examDetail'
              )
            }}</v-tab>
            <v-tab
              v-if="typeOfExam == false"
              class="subtitle-1 tab-exam uppercast-unset"
              href="#question"
              :disabled="!examId"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.examQuestion'
                )
              }}</v-tab
            >
            <v-tab
              v-if="typeOfExam == true"
              class="subtitle-1 tab-exam uppercast-unset"
              href="#question"
              :disabled="!examId || arrTagLevel.length == 0"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.examQuestion'
                )
              }}</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="main_tabs">
            <v-tab-item value="detail">
              <template>
                <v-form
                  ref="form"
                  v-model="valid"
                  v-on:submit.prevent="validate"
                >
                  <v-row>
                    <v-col cols="12" :lg="12" :md="12" :sm="12">
                      <p class="title">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.examName'
                          )
                        }}
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        outlined
                        v-model="title"
                        :rules="nameRules"
                        :placeholder="
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.pleaseFillName'
                          )
                        "
                        required
                        clearable
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <p class="title mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.typeExam'
                          )
                        }}
                        <span v-if="!examId" class="subtitle-1">{{
                          ' (' +
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.remarkTypeExam'
                          ) +
                          ') '
                        }}</span>
                      </p>
                      <v-row v-if="!examId">
                        <v-col cols="12">
                          <v-radio-group
                            v-model="typeOfExam"
                            mandatory
                            row
                            hide-details="auto"
                          >
                            <v-radio
                              :label="
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.typeExamGeneral'
                                )
                              "
                              :value="false"
                            ></v-radio>
                            <v-radio
                              :label="
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.typeExamCustomizable'
                                )
                              "
                              :value="true"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-if="typeOfExam == true">
                      <v-alert text dense type="info" border="left">
                        <strong class="font-weight-bold">{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.instructionQuestion'
                          )
                        }}</strong>
                        <br />
                        <strong class="font-weight-bold">
                          <label class="headExplan">"</label
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.mssg20'
                            )
                          }}
                          <label class="headExplan">"</label>
                        </strong>
                        <br />{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.mssg21'
                          )
                        }}
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row v-if="!examId">
                    <v-col class="text-right">
                      <v-btn
                        :disabled="title == ''||title.length > 30"
                        elevation="0"
                        class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                        @click="validate(null)"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.mssg22'
                          )
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </template>
            </v-tab-item>
            <v-tab-item value="question">
              <v-card-actions class="mt-7">
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
            )
          }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureExamDialog"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFail" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text v-if="time == true && mins == 0 && secs == 0"
          >-
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.failedMsg1'
            )
          }}</v-card-text
        >
        <v-card-text v-if="repeat == 5 && repeatTimes == 0"
          >-
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.failedMsg2'
            )
          }}</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogFail = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.ok'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSaveFail" persistent max-width="450" color="white">
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogSaveFail = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import draggable from "vuedraggable";
import { Datetime } from 'vue-datetime';
import { insertExam } from '@/service/course/exam';
import buttonAddExam from '@/views/course/dialog/insertExamDialog.vue';
import { insertLecture } from '@/service/course/course';

import $ from 'jquery';
export default {
  name: 'simple',
  display: 'Simple',
  order: 0,
  props: {
    // examId: {
    //   type: String
    // },
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
    courseId: {
      type: String,
    },
  },
  data: function () {
    return {
      item: 1,
      examId: null,
      randomSetting: null,
      maxWidth: '40%',
      timeout: 5000,
      dialog: false,
      newLectureID: null,
      dialogFail: false,
      dialogSaveFail: false,
      valid: true,
      value: 10,
      interval: 0,
      nameRules: [(v) => !!v || 'กรุณากรอกชื่อชุดข้อสอบ',
                  (v) => (v && v.length <= 30) || 'ชื่อชุดข้อสอบต้องไม่มากกว่า 30 ตัวอักษร'],
      time: false,
      repeat: 0, // 0, 1, ...
      repeatTimes: 0,
      mins: 0,
      secs: 0,
      answer: 1, // 0, 1, 2
      choiceType: 'number', // "thai", "english", "number"
      //drag variable
      enabled: true,
      questions: [],
      examDetail: null,
      title: '',
      description: '',
      randomQuestion: false,
      chooseRandomQuestion: false,
      conditionalRandom: false,

      isModifyStartEndTime: false,
      startTime: '',
      endTime: '',
      warnningToSaveDialog: false,
      main_tabs: 'detail',
      resultLecture: null,
      tagLevel: '',
      arrTagLevel: [],
      typeOfExam: false,
      loading: true,
      randomChoices: false,
      setPercent: false,
      percentExam: 0,
      loadingbtn: false,
    };
  },
  watch: {
    isModifyStartEndTime(val) {
      if (val == false) {
        this.startTime = '';
        this.endTime = '';
      } else {
        let oneDayMilli = 86400000;
        let currentDate = new Date();
        let initStartDateMilli = new Date(currentDate.getTime()).toISOString();
        let initEndDateMilli = new Date(
          currentDate.getTime() + oneDayMilli
        ).toISOString();
        if (this.examDetail) {
          if (
            this.examDetail.startTime == 0 ||
            this.examDetail.startTime == null
          ) {
            this.startTime = initStartDateMilli;
          } else {
            this.startTime = new Date(this.examDetail.startTime).toISOString();
          }

          if (this.examDetail.endTime == 0 || this.examDetail.endTime == null) {
            this.endTime = initEndDateMilli;
          } else {
            this.endTime = new Date(this.examDetail.endTime).toISOString();
          }
        } else {
          this.startTime = initStartDateMilli;
          this.endTime = initEndDateMilli;
        }
      }
    },
    time(val) {
      if (val == false) {
        this.mins = 0;
        this.secs = 0;
      } else {
        if (this.examDetail) {
          let timeMilliSec = this.examDetail.timeUse;
          this.mins = parseInt(timeMilliSec / 1000.0 / 60.0);
          this.secs = (timeMilliSec / 1000.0) % 60.0;
        }
      }
    },
    repeatTimes(val) {
      if (val != 0 && val != 1) {
        this.repeat = 5;
      }
    },
    repeat(val) {
      if (val == 0) {
        this.repeatTimes = 0;
      } else if (val == 1) {
        this.repeatTimes = 1;
      } else {
        if (this.examDetail) {
          this.repeatTimes = this.examDetail.limited;
        }
      }
    },
  },
  methods: {
    closeLectureExamDialog() {
      this.resetInitForm();
      this.closeLectureDialog();
      this.warnningToSaveDialog = false;
    },
    resetInitForm() {
      this.main_tabs = 'detail';
      this.title = '';
      this.description = '';
      this.time = false;
      this.repeat = 0;
      this.answer = 1;

      this.isModifyStartEndTime = false;
      this.randomQuestion = false;
      this.newLectureID = '';
      this.examId = null;

      this.tagLevel = '';
      this.arrTagLevel = [];
      this.typeOfExam = false;
      this.conditionalRandom = false;
      this.page = 1;
      this.setPercent = false;
      this.percentExam = 0;
      this.randomChoices = false;

      this.warnningToSaveDialog = false;
      this.$refs.form.resetValidation();
    },
    async validate(item) {
      if (this.loadingbtn) {
        return 0;
      }
      this.loadingbtn = true;
      this.warnningToSaveDialog = false;
      if (this.$refs.form.validate()) {
        let timeMins = parseInt(this.mins) * 60;
        let timeSecs = parseInt(this.secs);
        let timeMilliSec = (timeMins + timeSecs) * 1000;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        if (!this.newLectureID) {
          if (this.time == true && Math.abs(timeMilliSec) == 0) {
            this.dialogFail = true;
          } else if (this.repeat == 5 && this.repeatTimes == 0) {
            this.dialogFail = true;
          } else {
            let exam = await insertExam({
              title: this.title,
              description: this.description,
              choiceFormat: this.choiceType,
              questions: [],
              countTime: this.time,
              timeUse: Math.abs(timeMilliSec),
              showAnswer: this.answer,
              randomChoice: this.randomChoices,
              randomQuestion:
                this.typeOfExam == true ? true : this.randomQuestion,
              randomSetting:
                this.typeOfExam == true ? true : this.chooseRandomQuestion,
              chooseQuestion: this.setNumberClause,
              randomIsFirst: this.conditionalRandom,
              typeCheckExam: this.setPercent == true ? 'percentage' : '',
              checkPercent: this.percentExam,
              isReset: false, //รอทำจริงมีuiแล้ว, ปรึกษาหลายคน
              limited:
                this.repeat != 1 && this.repeat != 0
                  ? this.repeatTimes
                  : this.repeat,
              courses: this.$route.query.id,
            });
            if (exam.code && exam.code != 200) {
              this.dialogSaveFail = true;
            } else {
              let result = await insertLecture({
                id: this.sectionId,
                title: this.title,
                description: this.description,
                exams: [exam._id],
                type: 'EXAM',
              });
              if (result.code && result.code != 200) {
                this.dialogSaveFail = true;
              }
              this.$router.push({
                name: 'tab-exam',
                query: {
                  id: this.courseId,
                  lectureId: result._id,
                  sectionId: this.sectionId,
                  type: 'EXAM',
                },
                params: {
                  firstEdit: true,
                },
              });
            }
          }
        }
      }
    },
    async checkToSave() {
      this.reload();
      let timeMins = parseInt(this.mins) * 60;
      let timeSecs = parseInt(this.secs);
      let timeMilliSec = (timeMins + timeSecs) * 1000;
      let startTime = new Date(this.startTime).getTime();
      let endTime = new Date(this.endTime).getTime();

      let data = {
        title: this.title ? this.title : '',
        description: this.description ? this.description : '',
        choiceFormat: this.choiceType,
        countTime: this.time,
        showAnswer: this.answer,
        startTime: this.isModifyStartEndTime ? startTime : 0,
        endTime: this.isModifyStartEndTime ? endTime : 0,
        randomQuestion: this.randomQuestion,
        timeUse: Math.abs(timeMilliSec),
        limited:
          this.repeat != 1 && this.repeat != 0 ? this.repeatTimes : this.repeat,
      };

      let target = {
        title: '',
        description: '',
        choiceFormat: 'number',
        countTime: false,
        showAnswer: 1,
        startTime: 0,
        endTime: 0,
        randomQuestion: false,
        timeUse: 0,
        limited: 0,
        tagLevel: '',
        arrTagLevel: [],
      };

      JSON.stringify(data) !== JSON.stringify(target)
        ? this.examId
          ? this.closeLectureExamDialog()
          : (this.warnningToSaveDialog = true)
        : this.closeLectureExamDialog();
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '40%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>

<style scoped>
.bg-card {
  /* background: #fafafa !important; */
}
.center {
  justify-content: center;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.fix-width {
  max-width: 80px;
}
/* .set-date-exam {
  width: 80%;
} */
.datetime {
  padding: 10px;
  box-shadow: 0 0 0px 0 rgba(0, 0, 0, 0.19) !important;
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
  text-align: center;
  height: 45px;
  transition: box-shadow 0.3s ease-in-out;
}

.lecture-type-card {
  width: 100%;
  padding-bottom: 40%;
  padding-top: 40%;

  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lecture-type-card:hover {
  transform: scale(1.15, 1.15);
  cursor: pointer;
}
.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lesson-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 0px 0px 15px 15px;
  transition: transform 0.3s ease-in-out;
}

.text-right {
  text-align: right;
}

.input-number {
  height: 45px !important;
}

.input-number > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.input {
  height: 45px !important;
}

.input > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.input-number
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  text-align: right;
}

.dialogStyle {
  height: 1000px;
}

.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}

.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%;
  /* 1:1 Aspect Ratio */
  padding-top: 50%;
  /* border-radius: 50px; */
}

.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}

.colCenter {
  text-align: center;
}

.textField {
  width: 100%;
}

.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}

p {
  margin: 0 0 5px;
}

.examplePDF {
  /* height: 450px; */
  text-align: center;
}

.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}

.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}

.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}

.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}

.manageButton {
  justify-content: flex-end;
}

.textAreaDetail {
  border-radius: 15px;
}

.divExplanFile {
  justify-content: flex-end;
}

.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.labelExplan {
  text-align: justify;
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.editor .ql-container {
  min-height: 150px;
}

@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}

/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
<style scoped>
.card-custom {
  border-radius: 4px 4px 0 0 !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-bottom: 0 !important;
  background: #eeeeee !important;
}
.card-child {
  border-radius: 0 0 4px 4px !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-top: 0 !important;
}
</style>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.border {
  border: 1px solid rgb(195, 195, 195) !important;
}
.position-relative {
  position: relative;
}
.colon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}
.v-tab--active {
  background: #fff !important;
  color: #009bde;
}

.tab-live {
  border-radius: 10px 10px 0 0;
  background: #fafafa;
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}
/* .v-tab--active {
  background: #1976d2 !important;
  color: #fff;
} */
/* .v-tab.v-tab {
  color: #fff;
} */
.uppercast-unset {
  text-transform: unset;
}
.tab-exam {
  border-radius: 10px 10px 0 0;
  background: #fafafa;
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}
</style>
